import React from "react"
import styles from "./styles.scss"

const FooterColumn = ({ title, children }) => (
  <div className={styles.container}>
    <div className={styles.wrapper}>
      <b className={styles.title}>{title}</b>
      {React.Children.map(children, child => (
        <div className={styles.listItem}>{child}</div>
      ))}
    </div>
  </div>
)

export default FooterColumn



// WEBPACK FOOTER //
// ./src/components/Footer/FooterColumn/index.jsx